<template>
  <div>
    <div :style="{ zIndex: 500, bottom: positionBottom, left: positionLeft }" class="download-modal">
      <div v-if="playerInfos.infoOptions?.list_lang.length">
        <div v-for="item in [{ lang: 'source' }].concat(
          playerInfos.infoOptions?.list_lang
        )" :key="item.lang" :class="checkedValues.indexOf(item.lang) !== -1
  ? 'vjs-download-menu-lang selected'
  : 'vjs-download-menu-lang'
  " @click="handleSelect(item.lang)">
          <span class="checkmark">
            <span class="check"> </span>
          </span>
          <label :for="item.lang">{{ item.lang }}</label>
        </div>
      </div>
      <button class="vjs-download" @click="download" :disabled='!checkedValues.length'>
        <svg width="14" height="13" viewBox="0 0 14 13" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M1 9.16413V9.87097C1 10.4356 1.23705 10.9771 1.65901 11.3764C2.08097 11.7757 2.65326 12 3.25 12H10.75C11.3467 12 11.919 11.7757 12.341 11.3764C12.7629 10.9771 13 10.4356 13 9.87097V9.16129M7 1V8.80645M7 8.80645L9.625 6.32258M7 8.80645L4.375 6.32258"
            stroke="white" stroke-linecap="round" stroke-linejoin="round" />
        </svg>

        {{ $t("buttons.download") }}
      </button>
    </div>
  </div>
</template>

<script>
import { defineComponent } from "vue";
import en from "../../../i18n/en_US";
import fr from "../../../i18n/fr_FR";
import axios from "axios";

export default defineComponent({
  name: "download-modal",
  i18n: {
    messages: {
      en: en,
      fr: fr,
    },
  },
  props: {
    player: {
      required: true,
      type: Object,
    },
    showDownloadModal: {
      required: true,
      type: Function,
    },
    closeDownloadModal: {
      type: Function,
    },
    playerInfos: {
      type: Object,
      required: true,
    },
    cryptext: {
      required: true,
    },
  },
  data() {
    return {
      checkedValues: ["source"],
      positionBottom: 0,
      positionLeft: 0,
    };
  },
  mounted() {
    const targetElement = document.querySelector(
      ".vjs-control.vjs-button.customDownloadButton"
    );
    if (targetElement) {
      const rect = targetElement.getBoundingClientRect();
      this.positionBottom = `${rect.height + 15}px`;
      this.positionLeft = `${rect.left}px`;
    }
  },
  methods: {
    download() {
      let downloadUrl = `https:${window.process?.env.URL_LIVE_INTRANET === window.location.hostname ? "//" + window.process?.env.URL_LIVE_INTRANET + "/player" : window.process?.env?.API_PLAYER}/api/video/download/${this.cryptext}`;

      if (this.checkedValues.length) {
        this.checkedValues.forEach(async (item) => {
          if (item !== "source") {
            await axios
              .get(downloadUrl + `?lang=${item}`, {
                headers: {
                  authorization: `Bearer ${window.process?.env?.API_TOKEN}`,
                },
              })
              .then((response) => {
                let fileUrl = response?.data?.data?.file;
                if (fileUrl) {
                  window.open(fileUrl, "_blank");
                }
              })
              .catch((e) => {
                console.log("error download", e);
              });
          } else {
            axios
              .get(downloadUrl, {
                headers: {
                  authorization: `Bearer ${window.process?.env?.API_TOKEN}`,
                },
              })
              .then((response) => {
                let fileUrl = response?.data?.data?.file;
                if (fileUrl) {
                  window.open(fileUrl, "_blank");
                }
              })
              .catch((e) => {
                console.log("error download", e);
              });
          }
        });
      }
    },
    handleSelect(item) {
      if (item) {
        const index = this.checkedValues.indexOf(item);
        if (index !== -1) {
          this.checkedValues.splice(index, 1);
        } else {
          this.checkedValues.push(item);
        }
      }
    },
  },
});
</script>

<style scoped>
.download-modal {
  position: absolute;
  padding: 0.2em;
  border-radius: 5px;
  font-size: 1em;
  background: var(--vm-color-one-08);
}

.download-modal .vjs-download {
  padding: 0.25em 0;
}

.vjs-download-menu-lang {
  padding: 0.25em 0;
  border-bottom: 1px solid var(--vm-color-three);
  text-transform: capitalize;
  display: flex;
}

.vjs-download-menu-lang .checkmark {
  display: block;
  width: 1em;
  height: 1em;
  border: 1px solid;
  margin-right: 3px;
  border-radius: 3px;
}

.vjs-download-menu-lang.selected .check {
  display: block;
  left: 25%;
  position: relative;
  top: 0%;
  width: 40%;
  height: 75%;
  border: solid var(--vm-color-three);
  border-width: 0 2px 2px 0;
  transform: rotate(45deg);
}

.vjs-download-menu-lang input:checked~label,
.vjs-download-menu-lang label:hover,
.vjs-download-menu-lang label:hover~label {
  color: var(--vm-color-three) !important;
}

.download-modal button {
  cursor: pointer;
}
</style>
